import { makeService } from './api';

const service = makeService('contacts');

export default service;